import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface PriceCategorieState {
  priceCategorieList?: any
  priceCategorieDetail?: any
}

const initialState: PriceCategorieState = {
  priceCategorieList: {},
  priceCategorieDetail: {},
}

export const priceCategorieDucks = createSlice({
  name: 'priceCategorie',
  initialState,
  reducers: {

    getListPriceCategorie: (state: RootState, action: PayloadAction<any>) => {
      state.priceCategorieList = { loading: true, queryStr: action.payload }
    },
    getListPriceCategorieSuccess: (state, action: PayloadAction<any>) => {
      state.priceCategorieList = { loading: false, ...action.payload }
    },
    getListPriceCategorieFail: (state, action: PayloadAction<any>) => {
      state.priceCategorieList = { loading: false, ...action.payload }
    },

    getDetailPriceCategorie: (state: RootState, action: PayloadAction<any>) => {
      state.priceCategorieDetail = { loading: true, id: action.payload }
    },
    getDetailPriceCategorieSuccess: (state, action: PayloadAction<any>) => {
      state.priceCategorieDetail = { loading: false, ...action.payload }
    },
    getDetailPriceCategorieFail: (state, action: PayloadAction<any>) => {
      state.priceCategorieDetail = { loading: false, ...action.payload }
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListPriceCategorie,
  getListPriceCategorieSuccess,
  getListPriceCategorieFail,
  getDetailPriceCategorie,
  getDetailPriceCategorieSuccess,
  getDetailPriceCategorieFail,
} = priceCategorieDucks.actions

export default priceCategorieDucks.reducer
